import styled from '@emotion/styled';

import { COLOR_TEXT_MUTED } from './utils/variables';

export const BreadcrumbNav = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
  color: ${COLOR_TEXT_MUTED};
`;
